"use client";

import { createContext } from "react";

export interface SidebarContextProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  animate: boolean;
}

export const SidebarContext = createContext<SidebarContextProps | undefined>(
  undefined,
);
